import script from "./BaseYmForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseYmForm.vue?vue&type=script&lang=ts&setup=true"

import "./BaseYmForm.vue?vue&type=style&index=0&id=c2b78338&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2b78338"]])

export default __exports__